<template>
  <form-layout :label="label">
    <read-only-input v-if="!multiline" :value="value" />
    <div v-else class="form-control-plaintext text-break text-browse-item__multiline">{{ value }}</div>
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout'
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";

export default {
  name: "TextBrowseItem",
  components: {
    FormLayout,
    ReadOnlyInput,
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, null],
      required: true
    },
    multiline: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped>
.text-browse-item__multiline {
  white-space: pre-line;
}
</style>
